// /* eslint-disable @typescript-eslint/no-unused-vars */
// /* eslint-disable react-hooks/exhaustive-deps */
// import { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import {
//   useClientConfigurationData,
//   useUpdateConfigurationMutation,
// } from "../../../apis/profileApis";
// import Input from "../../../components/Input";
// import toast from "react-hot-toast";
// import { useFetchCountriesAllData } from "../../../apis/locationApis";
// import SelectInput from "../../../components/Select";
// import { timezoneCities } from "../../../utilities/helper";
// import { getTimezonesForCountry } from "countries-and-timezones";
// import moment from "moment-timezone";
// import { IconDeviceFloppy, IconEdit } from "@tabler/icons-react";

// type FormValues = {
//   country: string;
//   currency: string;
//   timeZone: string;
//   dateFormat: string;
// };

// export default function Configuration() {
//   const [isEdit, setIsEdit] = useState(false);
//   const {
//     register,
//     handleSubmit,
//     reset,
//     setValue,
//     watch,
//     formState: { errors },
//   } = useForm<FormValues>();
//   const { data, refetch } = useClientConfigurationData();
//   const { mutate } = useUpdateConfigurationMutation();
//   const [selectedCountry, setSelectedCountry] = useState<any>();
//   const { data: countryData } = useFetchCountriesAllData();
//   useEffect(() => {
//     if (data) {
//       setValue(
//         "country",
//         countryData?.find((e: any) => e?.name === data?.country)
//       );
//       setSelectedCountry(
//         countryData?.find((e: any) => e?.name === data?.country)
//       );
//       setValue("currency", data?.currency);
//       setValue("timeZone", data?.timeZone);
//       setValue("dateFormat", data?.dateFormat);
//     }
//   }, [data, countryData]);

//   const getTimeZoneByCountry = (countryCode: string) => {
//     const timezones = getTimezonesForCountry(countryCode);
//     if (!timezones) return null;

//     // Helper function to format city names
//     const formatCityName = (timezoneName: string): string => {
//       return (
//         timezoneCities[timezoneName] ||
//         timezoneName.split("/").pop() ||
//         timezoneName
//       );
//     };

//     const timeZoneData = timezones.map((tz: any) => {
//       const offset = moment.tz(tz.name).format("Z"); // +05:30
//       const label = `(UTC ${offset}) ${formatCityName(tz.name)}`;

//       setValue("timeZone", label);
//       return {
//         name: tz.name, // Asia/Kolkata
//         label: label, // (UTC +05:30) Chennai, Kolkata, Mumbai, New Delhi
//       };
//     });
//   };

//   const onSubmit = (data: any) => {
//     mutate(
//       { ...data },
//       {
//         onSuccess: () => {
//           reset();
//           refetch();
//           setIsEdit(!isEdit);
//           toast.success("Configuration Update Successfully.");
//         },
//         onError: (error) => {
//           console.log(error, "error");
//           toast.error(`${error}`);
//         },
//       }
//     );
//   };
//   return (
//     <div className="divide-y divide-[#212121]/20 space-y-2">
//       <div className="flex justify-between items-center space-y-4 py-2">
//         <label className="w-full text-base text-[#212121]">
//           Country / Currency <span className="text-red-600 ml-1">*</span>
//         </label>
//         <div className="flex items-center w-full gap-2">
//           {isEdit ? (
//             <SelectInput
//               name="country"
//               className="w-full"
//               label=""
//               placeholder="Select Country"
//               selectOptions={
//                 countryData?.map((country: any) => ({
//                   id: country?.id,
//                   value: country?.name,
//                   text: country?.name,
//                 })) || []
//               }
//               register={register}
//               validation={{ required: "Country is required" }}
//               error={errors.country}
//               disabled={!countryData || countryData.length === 0 || !isEdit}
//               value={selectedCountry?.name}
//               setValue={(val: string) => {
//                 setSelectedCountry(
//                   countryData.find((e: any) => e?.name === val)
//                 );
//                 setValue("country", val);
//                 setValue(
//                   "currency",
//                   countryData.find((e: any) => e?.name === val)?.currencyCode
//                 );
//                 getTimeZoneByCountry(
//                   countryData.find((e: any) => e?.name === val)?.countryCode
//                 );
//               }}
//             />
//           ) : (
//             <Input
//               name="country"
//               value={selectedCountry?.name || "—"}
//               type="text"
//               placeholder=" "
//               register={register}
//               error={errors.country}
//               validation={{ required: "country is required" }}
//               className="w-full"
//               inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                 isEdit
//                   ? "bg-white border border-[#D8D8D8]"
//                   : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//               }`}
//               disabled={true}
//             />
//           )}
//           <Input
//             name="currency"
//             type="text"
//             placeholder=" "
//             register={register}
//             error={errors.currency}
//             validation={{ required: "Currency is required" }}
//             className="w-full"
//             inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//               isEdit
//                 ? "bg-white border border-[#D8D8D8]"
//                 : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//             }`}
//             disabled={true}
//           />
//         </div>
//       </div>

//       <Input
//         className="flex justify-between items-center w-full py-2"
//         labelClass="w-full"
//         name="timeZone"
//         title="Time Zone"
//         type="text"
//         placeholder=" "
//         register={register}
//         error={errors.timeZone}
//         validation={{ required: "Timezone is required" }}
//         inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//           isEdit
//             ? "bg-white border border-[#D8D8D8]"
//             : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//         }`}
//         disabled={true}
//       />
//       <div className="flex justify-between items-center space-y-4 py-2">
//         <label className="w-full text-base text-[#212121]">
//           Date Format <span className="text-red-600 ml-1">*</span>
//         </label>
//         <div className="flex items-center w-full gap-2">
//           {isEdit ? (
//             <SelectInput
//               name="dateFormat"
//               className="w-full"
//               label=""
//               placeholder="Select Date Format"
//               selectOptions={
//                 ["DD-MM-YY", "DD-MM-YYYY"]?.map((country: any) => ({
//                   id: country,
//                   value: country,
//                   text: country,
//                 })) || []
//               }
//               disabled={!isEdit}
//               register={register}
//               validation={{ required: "Date format is required" }}
//               value={watch("dateFormat")}
//               error={errors.dateFormat}
//               setValue={(val: string) => {
//                 setValue("dateFormat", val);
//               }}
//             />
//           ) : (
//             <Input
//               name="dateFormat"
//               value={watch("dateFormat")}
//               type="text"
//               placeholder=" "
//               register={register}
//               error={errors.country}
//               validation={{ required: "dateFormat is required" }}
//               className="w-full"
//               inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
//                 isEdit
//                   ? "bg-white border border-[#D8D8D8]"
//                   : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
//               }`}
//               disabled={true}
//             />
//           )}
//         </div>
//       </div>
//       <button
//         onClick={() => {
//           isEdit ? handleSubmit(onSubmit)() : setIsEdit(!isEdit);
//         }}
//         className="bg-[#FBD037] text-[#212121] text-base font-semibold  p-2.5 rounded-full"
//       >
//         {isEdit ? <IconDeviceFloppy /> : <IconEdit />}
//       </button>
//     </div>
//   );
// }

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  useClientConfigurationData,
  useUpdateConfigurationMutation,
} from "../../../apis/profileApis";
import Input from "../../../components/Input";
import toast from "react-hot-toast";
import { useFetchCountriesAllData } from "../../../apis/locationApis";
import SelectInput from "../../../components/Select";
import { timezoneCities } from "../../../utilities/helper";
import { getTimezonesForCountry } from "countries-and-timezones";
import moment from "moment-timezone";
import { IconDeviceFloppy, IconEdit } from "@tabler/icons-react";
import { useLanguage } from "../../../context/LanguageContext";

type FormValues = {
  country: string;
  currency: string;
  timeZone: string;
  dateFormat: string;
};

export default function Configuration() {
  const { t } = useLanguage();
  const [isEdit, setIsEdit] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm<FormValues>();

  const { data, refetch } = useClientConfigurationData();
  const { mutate } = useUpdateConfigurationMutation();
  const { data: countryData } = useFetchCountriesAllData();

  // ✅ Load and set default form values
  useEffect(() => {
    if (data && countryData?.length) {
      const countryObj = countryData.find(
        (e: any) => e?.name === data?.country
      );
      if (countryObj) {
        setSelectedCountry(countryObj);
        setValue("country", countryObj.name); // ✅ ensure string, not object
        setValue("currency", countryObj.currencyCode || data?.currency);
        setValue("timeZone", data?.timeZone);
        setValue("dateFormat", data?.dateFormat);
      }
    }
  }, [data, countryData]);

  const getTimeZoneByCountry = (countryCode: string) => {
    const timezones = getTimezonesForCountry(countryCode);
    if (!timezones) return null;

    const formatCityName = (timezoneName: string): string => {
      return (
        timezoneCities[timezoneName] ||
        timezoneName.split("/").pop() ||
        timezoneName
      );
    };

    const timeZoneData = timezones.map((tz: any) => {
      const offset = moment.tz(tz.name).format("Z"); // +05:30
      const label = `(UTC ${offset}) ${formatCityName(tz.name)}`;
      return {
        name: tz.name,
        label: label,
      };
    });

    // Set default timezone (first one)
    if (timeZoneData.length > 0) {
      setValue("timeZone", timeZoneData[0].label);
    }
  };

  const onSubmit = (formData: FormValues) => {
    mutate(
      { ...formData },
      {
        onSuccess: () => {
          refetch();
          setIsEdit(false);
          toast.success(t("Configuration updated successfully."));
        },
        onError: (error) => {
          console.error(error);
          toast.error(t("Failed to update configuration."));
        },
      }
    );
  };

  return (
    <div className="divide-y divide-[#212121]/20 space-y-2">
      {/* Country / Currency Section */}
      <div className="flex justify-between items-center space-y-4 py-2">
        <label className="w-full text-base text-[#212121]">
          {t("Country / Currency")} <span className="text-red-600 ml-1">*</span>
        </label>
        <div className="flex items-center w-full gap-2">
          {isEdit ? (
            <SelectInput
              name="country"
              className="w-full"
              label=""
              placeholder="Select Country"
              selectOptions={
                countryData?.map((country: any) => ({
                  id: country?.id,
                  value: country?.name,
                  text: country?.name,
                })) || []
              }
              register={register}
              validation={{ required: t("Country is required") }}
              error={errors.country}
              disabled={!isEdit}
              value={selectedCountry?.name}
              setValue={(val: string) => {
                const found = countryData.find((e: any) => e?.name === val);
                if (found) {
                  setSelectedCountry(found);
                  setValue("country", found.name); // ✅ keep as string
                  setValue("currency", found.currencyCode);
                  getTimeZoneByCountry(found.countryCode);
                }
              }}
            />
          ) : (
            <Input
              name="country"
              value={selectedCountry?.name || "—"}
              type="text"
              placeholder=" "
              register={register}
              error={errors.country}
              className="w-full"
              inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
                isEdit
                  ? "bg-white border border-[#D8D8D8]"
                  : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
              }`}
              disabled
            />
          )}

          <Input
            name="currency"
            type="text"
            placeholder=" "
            register={register}
            error={errors.currency}
            validation={{ required: t("Currency is required") }}
            className="w-full"
            inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
              isEdit
                ? "bg-white border border-[#D8D8D8]"
                : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
            }`}
            disabled
          />
        </div>
      </div>

      {/* Time Zone */}
      <Input
        className="flex justify-between items-center w-full py-2"
        labelClass="w-full"
        name="timeZone"
        title="Time Zone"
        type="text"
        placeholder=" "
        register={register}
        error={errors.timeZone}
        validation={{ required: t("Timezone is required") }}
        inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
          isEdit
            ? "bg-white border border-[#D8D8D8]"
            : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
        }`}
        disabled
      />

      {/* Date Format */}
      <div className="flex justify-between items-center space-y-4 py-2">
        <label className="w-full text-base text-[#212121]">
          {t("Date Format")} <span className="text-red-600 ml-1">*</span>
        </label>
        <div className="flex items-center w-full gap-2">
          {isEdit ? (
            <SelectInput
              name="dateFormat"
              className="w-full"
              label=""
              placeholder="Select Date Format"
              selectOptions={["DD-MM-YY", "DD-MM-YYYY"].map((fmt) => ({
                id: fmt,
                value: fmt,
                text: fmt,
              }))}
              disabled={!isEdit}
              register={register}
              validation={{ required: t("Date format is required") }}
              value={watch("dateFormat")}
              error={errors.dateFormat}
              setValue={(val: string) => setValue("dateFormat", val)}
            />
          ) : (
            <Input
              name="dateFormat"
              value={watch("dateFormat")}
              type="text"
              placeholder=" "
              register={register}
              error={errors.dateFormat}
              className="w-full"
              inputClassName={`px-4 py-2 text-sm w-full rounded-full outline-none ${
                isEdit
                  ? "bg-white border border-[#D8D8D8]"
                  : "opacity-70 bg-gray-100 border border-[#D8D8D8] text-gray-700 cursor-not-allowed"
              }`}
              disabled
            />
          )}
        </div>
      </div>

      {/* Edit / Save Button */}
      <button
        onClick={() => {
          if (isEdit) handleSubmit(onSubmit)();
          else setIsEdit(true);
        }}
        className="bg-[#FBD037] text-[#212121] text-base font-semibold p-2.5 rounded-full"
      >
        {isEdit ? <IconDeviceFloppy /> : <IconEdit />}
      </button>
    </div>
  );
}
